import { QueovalDateTime, GQueovalDik, QueovalDate, QueovalBase, InputModel } from '../../global';


export class GetRequiredBoPropertiesModel {
  public idDonnee: string;
  public idBO: string;
  public forcedColumnNames: Array<string>;
  public exceptColumnNames: Array<string>;
  public DefaultInputs: Array<InputModel>;
}

export class DynamicTagsModel extends QueovalBase {
  public RequiredProperties: Array<IBoProperty<any>>;
}
export class DynamicTagsSaveModel extends QueovalBase {
  public Properties: Array<IBoProperty<any>>;
  public IdDonnee: string;
  public IdBo: string;
}

export class BoPropertyType {
  public static STRING: string = 'STRING';
  public static INT: string = 'INT';
  public static BOOLEAN: string = 'BOOLEAN';
  public static DATE: string = 'DATE';
  public static MONETARY: string = 'MONETARY';
}


export interface IBoProperty<T> {
  Label: string;
  Combo: Array<GQueovalDik<string, T>>;
  ColumnName: string;
  Type: string;
  highlight: boolean;
  Value: T | null;
}
export class BoProperty<T>
{
  public Label: string;
  public Combo: Array<GQueovalDik<string, T>>;
  public ColumnName: string;
  public Type: string;
  public highlight: boolean;
  constructor(label: string = "", combo: Array<GQueovalDik<string, T>> | null = null, columnName: string = '') {
    this.Label = label;
    this.Combo = combo != null ? combo : new Array<GQueovalDik<string, T>>();
    this.ColumnName = columnName;
    this.highlight = false;
  }
}
export class IntBoProperty extends BoProperty<number> implements IBoProperty<number>
{
  public Value: number | null;
  constructor(label: string = "", value: number | null = null, columnName: string = "", combo: Array<GQueovalDik<string, number>> | null = null) {
    super(label, combo, columnName);
    this.Value = value;
    this.Type = BoPropertyType.INT;
  }
}
export class StringBoProperty extends BoProperty<string> implements IBoProperty<string>
{
  public Value: string | null;
  constructor(label: string = "", value: string | null = null, columnName: string = "", combo: Array<GQueovalDik<string, string>> | null = null) {
    super(label, combo, columnName);
    this.Value = value;
    this.Type = BoPropertyType.STRING;
  }
}
export class DateRequiredBoProperty extends BoProperty<QueovalDateTime> implements IBoProperty<QueovalDateTime>
{
  public Value: QueovalDateTime | null;
  public DateMinutesList: Array<string>;
  constructor(label: string = "", value: QueovalDateTime | null = null, columnName: string = "", combo: Array<GQueovalDik<string, QueovalDateTime>> | null = null) {
    super(label, combo, columnName);
    this.Value = value;
    this.DateMinutesList = [];
    this.Type = BoPropertyType.DATE;
  }
}
export class MonetaryBoProperty extends BoProperty<number> implements IBoProperty<number>
{
  public Value: number | null;
  public Mask: string;
  constructor(label: string = "", value: number | null = null, columnName: string = "", combo: Array<GQueovalDik<string, number>> | null = null) {
    super(label, combo, columnName);
    this.Value = value;
    this.Type = BoPropertyType.MONETARY;
  }
}

export class BooleanBoProperty extends BoProperty<boolean> implements IBoProperty<boolean>
{
  public Value: boolean | null;
  constructor(label: string = "", value: boolean | null = null, columnName: string = "", combo: Array<GQueovalDik<string, boolean>> | null = null) {
    super(label, combo, columnName);
    this.Value = value;
    this.Type = BoPropertyType.BOOLEAN;
  }
}
